import { Component } from "react";
import { Form, Transfer } from "antd";
import { getLangList } from '@/lib/i18n';
import { modalFromLayout } from "@/lib/antdElementFunction";

interface props {
  form?: any;
  studentArray: any;
  allStudentArray: any;
}

interface state {
  allStudent: Array<object>;
  takeBusStudentKey: Array<string>;
}

class ModalStudent extends Component<props, state> {
  state = {
    allStudent: [],
    takeBusStudentKey: [],
  };
  busT: any = getLangList("bus");

  componentDidMount() {
    this.initStudentData();
  }

  initStudentData = () => {
    const { allStudentArray, studentArray, form } = this.props;
    const takeBusStudentKey = studentArray.map((item: any) => `${item.userAccountId}`);
    const allStudent = allStudentArray.map((item: any) => ({
      key: `${item.userAccountId}`,
      title: `${item.nameCn}-${item.nameEn}`,
    }));

    form.setFieldsValue({ takeBusStudentKey });
    this.setState({ allStudent, takeBusStudentKey });
  }

  changeStudent = (targetKeys: any) =>  this.setState({ takeBusStudentKey: targetKeys })

  render() {
    const { form } = this.props;
    const { allStudent, takeBusStudentKey } = this.state;

    return (
      <Form
        className="admin-form"
        style={{ marginTop: 20 }}
        {...modalFromLayout}
        form={form}
        initialValues={{
          takeBusStudentKey: [],
        }}
      >
        <Form.Item label={this.busT.TAKE_BUS_LIST} name="takeBusStudentKey">
          <Transfer
            dataSource={allStudent}
            showSearch
            filterOption={(inputValue: any, option: any) => option.title.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0}
            listStyle={{ width: 250, height: 300 }}
            targetKeys={takeBusStudentKey}
            onChange={this.changeStudent}
            render={item => item.title}
          />
        </Form.Item>
      </Form >
    );
  }
}

export default ModalStudent;